export default {"src":"/_next/static/media/car-fill.e30533ef.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};